import type { EagleHost } from './host';
import { createEagleConsole } from './route';
import { serviceScopes } from './service';

/**
 * The module for the app to mount: its CDN-provider console and catalog scope (plain data and a
 * loader; the console stays a lazy chunk behind `route.ts`). The host is a lazy factory, not a
 * value: the app file that builds it imports the service-scoped CDN analytics hooks, which the
 * entry chunk does not need, so it is fetched when the route loads and registered before any code
 * of the console runs. Taking it is the only way to get the console, so the app cannot mount the
 * module and forget what it reads at render time.
 */
export function createEagleModule(loadHost: () => Promise<EagleHost>) {
  return { cdnProviderConsole: createEagleConsole(loadHost), serviceScopes };
}

export type { EagleHost } from './host';
